import {axios, createAsyncThunk} from '../thunk-config'

export default createAsyncThunk('payment/setPayPalCheckout', async ({merchant_id, order, data, headers}, {rejectWithValue}) => {
  try {
    return axios.post(`/utilv2/paypal_set_checkout/${merchant_id}`, {order, data}, {headers})
      .then(response => response.data.data.token)
      .catch(error => rejectWithValue(error))
  } catch(err) {
    if(!err.response) {
      throw err
    }

    return rejectWithValue(err.response.data)
  }
})


// WEBPACK FOOTER //
// ./client/resources/js/checkout/redux/thunks/setPaypalCheckout.js